<template>
    <div>
        <div class="google-map" ref="googleMap"></div>
        <template v-if="Boolean(this.google) && Boolean(this.map) && shops">
            <slot :google="google" :map="map" />
        </template>
    </div>
</template>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";
import Store from "../../store";
import { mapState } from "vuex";

export default {
    name: "google-maps-loader",
    props: {
        mapConfig: Object,
        apiKey: String
    },

    data() {
        return {
            google: null,
            map: null
        };
    },

    async mounted() {
        let googleMapApi;
        googleMapApi = await GoogleMapsApiLoader({
            apiKey: this.apiKey
        });
        if (!googleMapApi) {
            googleMapApi = await GoogleMapsApiLoader({
                apiKey: this.apiKey
            });
        }
        this.google = googleMapApi;
        Store.commit("ShopsMapStore/setGoogle", this.google);

        await this.initializeMap();
    },
    computed: {
        ...mapState("ShopsMapStore", ["shops"])
    },

    methods: {
        async initializeMap() {
            const mapContainer = this.$refs.googleMap;
            this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
            Store.commit("ShopsMapStore/setMap", this.map);
            if (!this.map) {
                this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
                Store.commit("ShopsMapStore/setMap", this.map);
            }
        }
    }
};
</script>

<style scoped>
.google-map {
    min-height: 80vh;
    height: auto;
}
</style>
